export default __webpack_public_path__ + "static/media/rotate.f38aa4c2.gif";